import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Privacy.css";
import LoginModal from "./LoginModal";
import logoApp from "../assets/logo-app.png";

const Support = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="privacy-page">
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logoApp} alt="Runstreak Dashboard" className="nav-logo" />
            <span className="nav-brand-text">Runstreak Dashboard</span>
          </div>
          <div className="nav-menu">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-outlined">Login</button>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-primary">Get Started</button>
          </div>
        </div>
      </nav>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <div className="privacy-container">
        <div className="privacy-header">
          <h1>Support</h1>
          <p className="privacy-subtitle">We're here to help.</p>
        </div>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions, issues, or feedback about RunStreak
            Dashboard, please reach out by email and we'll get back to you as
            soon as possible.
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@runstreakdashboard.com">
              support@runstreakdashboard.com
            </a>
          </p>
        </section>

        <section className="privacy-section">
          <h2>Common Questions</h2>

          <h3>How do I connect Strava?</h3>
          <p>
            Go to your Profile and tap "Connect Strava". You'll be redirected to
            Strava to authorize the connection. Once approved, your activities
            will sync automatically.
          </p>

          <h3>My activities aren't syncing</h3>
          <p>
            Try pulling down to refresh on the Activities screen. If the problem
            persists, disconnect and reconnect Strava from your Profile. If
            you're still having trouble, contact us at the email above.
          </p>

          <h3>How is my streak calculated?</h3>
          <p>
            A streak counts consecutive days with at least one recorded running
            activity. Activities are synced from Strava automatically. The
            streak resets if a day passes with no run.
          </p>

          <h3>How do I delete my account?</h3>
          <p>
            To delete your account and all associated data, please contact us at{" "}
            <a href="mailto:support@runstreakdashboard.com">
              support@runstreakdashboard.com
            </a>{" "}
            and we'll process your request within 7 days.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Privacy & Terms</h2>
          <p>
            <Link to="/privacy">Privacy Policy</Link> &nbsp;·&nbsp;{" "}
            <Link to="/terms">Terms of Service</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Support;
